import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import { useSelector } from 'react-redux';
import { getPopulationRate } from '../../../reducer/morbidityRateSlice';

const attributeData = [
    {
        attribute: "patient",
        name_th: "จำนวนผู้ป่วย",
        unit_th: "ราย",
        name_us: "Cases",
        unit_us: "head"
    },
    {
        attribute: "population",
        name_th: "จำนวนประชากร",
        unit_th: "ราย",
        name_us: "Population",
        unit_us: "head"
    }
]

function MorbidityContent(props) {
    const { data } = props;
    const population = useSelector(getPopulationRate);
    // const mapDataSelected = useSelector(getMapDataSelected);


    // useEffect(() => {
    //     console.log(data);
    // }, [data])

    return (
        <Grid container spacing={2}>
            <Grid xs={12} sx={{
                backgroundColor: 'rgb(62, 152, 211)'
            }}>
                <Typography variant="h5" className="mb-2 font-primary" sx={{
                    padding: 2,
                    paddingBottom: 0,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `ต.${data.tambon_name}` :
                            data.amphur_name !== undefined ?
                                `อ.${data.amphur_name}` : `จ.${data.province_name}`
                    }
                </Typography>
                <Typography variant="h6" className="mb-2 font-primary" sx={{
                    fontWeight: 'normal',
                    paddingLeft: 2,
                    paddingRight: 2,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `อ.${data.amphur_name} จ.${data.province_name}` :
                            data.amphur_name !== undefined ?
                                `จ.${data.province_name}` : ``
                    }
                </Typography>
            </Grid>
            <Grid xs={12} sx={{
                borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
            }}>
                <Typography variant="subtitle1" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center'
                }}>
                    {
                        `อัตราป่วย ต่อประชากร ${population?.toLocaleString()} คน`
                    }
                </Typography>
                <Typography variant="h6" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center',
                    fontWeight: 'normal'
                }}>
                    {data.value}
                </Typography>
            </Grid>
            {
                attributeData.map((attribute, index) =>  {
                    return (
                        <React.Fragment key={index}>
                            <Grid xs={7}>
                                <Typography variant='body1' className="font-primary" sx={{
                                    paddingLeft: 2
                                }}>
                                    {attribute.name_th}
                                </Typography>
                            </Grid>
                            <Grid xs={3}>
                                <Typography variant='body1' className="font-primary" sx={{
                                    textAlign: 'right'
                                }}>
                                    {data[attribute.attribute].toLocaleString()}
                                </Typography>
                            </Grid>
                            <Grid xs={2}>
                                <Typography variant='body1' className="font-primary">
                                    {attribute.unit_th}
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    )
                })
            }
        </Grid>
    )
}

export default MorbidityContent;
